import React, { useState } from "react";
import { Modal } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";

import WelcomeScreen from "./WelcomeScreen";
import RegisterNumber from "./RegisterNumber";

import BuyNumber from "./BuyNumber";
import "./index.scss";

interface AddNumberFlowModalProps {
  visible: boolean;
  onClose: () => void;
}

const AddNumberFlowModal: React.FC<AddNumberFlowModalProps> = ({
  visible,
  onClose,
}) => {
  const [selectedOption, setSelectedOption] = useState("welcome");
  return (
    <Modal
      open={visible}
      onCancel={onClose}
      closable={false}
      footer={null}
      centered
      className="custom-modal add-number-flow-modal"
    >
      {selectedOption === "welcome" ? (
        <WelcomeScreen handleSelect={setSelectedOption} />
      ) : selectedOption === "register" ? (
        <RegisterNumber handleBackClick={() => setSelectedOption("welcome")}/>
      ) : (
        <BuyNumber handleBackToPrevious={() => setSelectedOption("welcome")} />
      )}
    </Modal>
  );
};

export default AddNumberFlowModal;
